import React from 'react'
import withFormState from 'src/components/aciacehighway/hocs/withFormState';
import { ScopedCssBaseline } from '@mui/material';
import EditSKUMgmt from '../component/sku-mgmt-form/edit/EditSKUMgmt';

function EditPage({ history, match: { params } }) {

  return (<ScopedCssBaseline>
    <EditSKUMgmt id={params.id} />
  </ScopedCssBaseline>);
}

export default withFormState(EditPage)
